module.exports = __webpack_public_path__ + "img/arm-fully-extended-in-case-of selfie.4de3f7bf.png";